import { createContext } from "react";
import { FinishedWalkthrough, User } from "@hooks/useGetUser"; // Adjust the import path as needed

interface UserContextType {
  user: User | null;
  finishedWalkthroughs: FinishedWalkthrough[];
  isLoading: boolean;
}

const defaultValue: User | null = null;
const defaultFinishedWalkthroughs: FinishedWalkthrough[] = [];

// Create context with default values
export const UserContext = createContext<UserContextType>({
  user: defaultValue,
  finishedWalkthroughs: defaultFinishedWalkthroughs,
  isLoading: false,
});
